import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../context/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 mt-24 relative z-10" data-testid="main-footer">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display text-2xl text-white">BuyDubai<span className="text-gold">.ai</span></div>
          <p className="mt-3 text-sm text-white/50 max-w-sm">{t("footer.blurb")}</p>
          <p className="mt-4 text-xs uppercase tracking-[0.2em] text-gold/70">{t("footer.powered")}</p>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">{t("footer.explore_h")}</div>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/ask" className="hover:text-gold">{t("nav.ask")}</Link></li>
            <li><Link to="/property" className="hover:text-gold">{t("nav.property")}</Link></li>
            <li><Link to="/projects" className="hover:text-gold">{t("nav.projects")}</Link></li>
            <li><Link to="/partners" className="hover:text-gold">{t("nav.partners")}</Link></li>
            <li><Link to="/partners/broker" className="hover:text-gold">{t("nav.broker")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">{t("footer.company_h")}</div>
          <ul className="space-y-2 text-sm text-white/60">
            <li><Link to="/about" className="hover:text-gold">{t("nav.about")}</Link></li>
            <li><Link to="/trust" className="hover:text-gold">{t("nav.trust")}</Link></li>
            <li><a href="mailto:partners@buydubai.ai" className="hover:text-gold">partners@buydubai.ai</a></li>
            <li><Link to="/privacy" className="hover:text-gold">{t("legal.privacy")}</Link></li>
            <li><Link to="/terms" className="hover:text-gold">{t("legal.terms")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-5 text-center text-xs text-white/40 px-5 space-y-1">
        <div data-testid="ai-disclaimer">{t("common.ai_disclaimer")}</div>
        <div>© {new Date().getFullYear()} BuyDubai.ai · {t("footer.powered")} · {t("footer.note")}</div>
      </div>
    </footer>
  );
};
